function checkLastEditedColumn(allowedColumns) {
  const lastUpdatedColumn = window.to_use_react_gantt.lastUpdatedColumn;
  if (lastUpdatedColumn === null || lastUpdatedColumn === undefined) {
    return true;
  }
  return allowedColumns.includes(lastUpdatedColumn);
}

export { checkLastEditedColumn };
